import {gql} from "@apollo/client";

export const INIT_RESET_PASSWORD = gql`
    mutation initResetPassword($email: String!) {
        initResetPassword(email: $email)
    }
`